import { Reducer } from 'redux'
import { ActionTypes, TFavoritesActivityState } from './types'
import { getDataForPagination, getMapData } from '../../../../utils/reducerUtils'

export const initialState: TFavoritesActivityState = {
  loading: false,
  data: null,
  childData: null,
}

const reducer: Reducer<TFavoritesActivityState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_FAVORITES_ACTIVITY_R:
      return { ...state, loading: true, errors: undefined }
    case ActionTypes.GET_FAVORITES_ACTIVITY_S:
      return { ...state, loading: false, errors: undefined, data: getDataForPagination(state.data, action.payload) }
    case ActionTypes.GET_FAVORITES_ACTIVITY_WITH_O_OFFSET_S:
      return { ...state, loading: false, errors: undefined, data: action.payload }
    case ActionTypes.GET_FAVORITES_ACTIVITY_E:
      return { ...state, loading: false, errors: action.payload, data: [] }

    case ActionTypes.GET_FAVORITES_ACTIVITY_CHILD_R:
      return { ...state, loading: true, errors: undefined }
    case ActionTypes.GET_FAVORITES_ACTIVITY_CHILD_S:
      return { ...state, loading: false, errors: undefined, childData: getMapData(state.childData, action.payload) }
    case ActionTypes.GET_FAVORITES_ACTIVITY_CHILD_E:
      return { ...state, loading: false, errors: action.payload }

    default:
      return state
  }
}

export { reducer as FavoritesActivityReducer }
